// cart_checkout_fix.js - force reliable checkout submit
(function forceCheckoutSubmit() {
  function findCartForm() {
    return (
      document.querySelector("form[action='/cart']") ||
      document.querySelector("form[action*='/cart']") ||
      document.querySelector("form.cart")
    );
  }

  function ensureCheckoutEnabled() {
    var buttons = document.querySelectorAll(
      "[name='checkout'], a[href^='/checkout'], a.btn.cart__checkout, button[type='submit']"
    );
    buttons.forEach(function (btn) {
      btn.style.pointerEvents = "auto";
      btn.disabled = false;
    });

    var style = document.getElementById("ymq-checkout-button-protect");
    if (style && style.parentNode) style.parentNode.removeChild(style);
  }

  function goCheckout() {
    var form = findCartForm();
    if (!form) {
      window.location.href = "/checkout";
      return;
    }

    var checkoutInput = form.querySelector("input[name='checkout']");
    if (!checkoutInput) {
      checkoutInput = document.createElement("input");
      checkoutInput.type = "hidden";
      checkoutInput.name = "checkout";
      checkoutInput.value = "Check out";
      form.appendChild(checkoutInput);
    }

    form.action = "/cart";
    form.method = "post";
    form.submit();
  }

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest("button, input[type='submit'], a")
        : null;
      if (!target) return;

      var text = String(target.innerText || target.value || "").trim().toLowerCase();
      var isCheckout =
        target.name === "checkout" ||
        target.id === "checkout" ||
        target.getAttribute("data-checkout") === "true" ||
        text === "check out" ||
        text === "checkout";

      if (!isCheckout) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      goCheckout();
    },
    true
  );

  ensureCheckoutEnabled();
  var observer = new MutationObserver(function () {
    ensureCheckoutEnabled();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setInterval(ensureCheckoutEnabled, 500);
})();


// cart_checkout_fix.js - allow app fees first, then fallback checkout
